import notice from './notice.data.js'

export default {
  notice: { ...notice }
}
